import { fetchEnquiriesApi } from "API/apis/enquiry/getEnquiries";
import { useGlobalContext } from "context/GlobalContext";
import { createContext, useContext, useEffect, useState } from "react";

import { message } from "constants/responses/message";
import { enquiryOperationsList } from "./constants/enquiry.constants";
import { useSearchParams } from "react-router-dom";
import { filterStringToObject } from "utils/functions/reactTableFilterConverter";

const EnquiryContext = createContext({
  currentOperationPage: "",
  setCurrentOperationPage: () => {},
  list: [],
  setList: () => {},
  previewEnquiry: {},
  setPreviewEnquiry: () => {},
  reloadRequired: false,
  setReloadRequired: () => {},
});

export const EnquiryProvider = ({ children }) => {
  const [searchParams] = useSearchParams();
  const paramsToObject = Object.fromEntries(searchParams.entries());

  const [list, setList] = useState([]);
  const [previewEnquiry, setPreviewEnquiry] = useState({});
  const [reloadRequired, setReloadRequired] = useState(false);
  const [currentOperationPage, setCurrentOperationPage] = useState(
    enquiryOperationsList.listEnquiry
  );

  const { setIsInitializing, setError, setIsLoading } = useGlobalContext();

  useEffect(() => {
    setAllParams({
      ...paramsToObject,
      filters: filterStringToObject(paramsToObject.filters),
    });
  }, [searchParams]);

  const [allParams, setAllParams] = useState({
    ...paramsToObject,
    filters: filterStringToObject(paramsToObject.filters) || "",
  });

  useEffect(() => {
    const fetchData = async () => {
      try {
        setIsInitializing(true);
        const { data, status } = await fetchEnquiriesApi(allParams);
        if (status !== 200) {
          throw new Error(message.error.generalFailure);
        }
        setList(data);
        setIsInitializing(false);
      } catch (error) {
        setError(error.message);
      } finally {
        setIsInitializing(false);
        setIsLoading(false);
        setReloadRequired(false);
      }
    };
    fetchData();
  }, [reloadRequired, allParams]);

  return (
    <EnquiryContext.Provider
      value={{
        currentOperationPage,
        setCurrentOperationPage,
        list,
        setList,
        previewEnquiry,
        setPreviewEnquiry,
        reloadRequired,
        setReloadRequired,
      }}
    >
      <>{children}</>
    </EnquiryContext.Provider>
  );
};

export const useEnquiryContext = () => {
  const context = useContext(EnquiryContext);
  if (!context) {
    throw new Error("useEnquiryContext must be used within a EnquiryProvider");
  }
  return context;
};
